import { useCallback, useRef, useEffect } from 'react';
import { PapiComment } from '@wix/da-papi-types';

export function useParentIndicators(
  parentComment?: PapiComment,
  parentCommentRef?: React.RefObject<HTMLElement | null>
) {
  const commentElements = useRef<{ [key in number]: HTMLDivElement }>({});
  const verticalIndicatorElements = useRef<{ [key in number]: HTMLDivElement }>(
    {}
  );

  const setVerticalIndicatorRef = useCallback(
    (commentId: number, element: HTMLDivElement) => {
      verticalIndicatorElements.current[commentId] = element;
    },
    []
  );
  const setCommentRef = useCallback(
    (commentId: number, element: HTMLDivElement | null) => {
      if (!element) {
        return;
      }

      commentElements.current[commentId] = element;
    },
    []
  );
  const onCommentMouseOver = useCallback(
    (
      commentId: number,
      parentId: number | null | undefined,
      isReplyingToParent: boolean
    ) => {
      if (
        !parentId ||
        !commentElements.current[commentId] ||
        !verticalIndicatorElements.current[commentId] ||
        isReplyingToParent
      ) {
        return;
      }
      let parentNode: HTMLDivElement | null = null;
      if (
        parentComment &&
        parentComment.commentId === parentId &&
        parentCommentRef
      ) {
        parentNode = parentCommentRef.current as any;
      } else {
        parentNode = commentElements.current[parentId];
      }
      if (!parentNode) {
        return;
      }
      const { top: commentTop } =
        commentElements.current[commentId].getBoundingClientRect();
      const { top: parentTop } = parentNode!.getBoundingClientRect();
      verticalIndicatorElements.current[commentId].style.height = `${
        commentTop - parentTop - 20
      }px`;
    },
    [parentComment, parentCommentRef]
  );

  useEffect(() => {
    if (parentComment && parentCommentRef) {
      setCommentRef(parentComment.commentId, parentCommentRef.current as any);
    }
  }, [parentComment, parentCommentRef, setCommentRef]);

  return { setVerticalIndicatorRef, setCommentRef, onCommentMouseOver };
}
